import { ThemeConfig, extendTheme } from '@chakra-ui/react'
import { default as tokens } from '@homebot/yar/dist/web/js/Homebot--Light.module.js'
import { styles } from './styles'
import { components } from './components'
import { textStyles } from './foundations'

const config: ThemeConfig = {
  cssVarPrefix: 'hb',
  initialColorMode: 'light',
  useSystemColorMode: false,
}

const storybookOptions = {
  background: '#fbfbfb',
}

// charka-cli requires a default export or a *theme* named export
export const theme = extendTheme({
  components,
  config,
  storybookOptions,
  styles,
  textStyles,
  ...tokens,
})
